import { render, staticRenderFns } from "./ReviewQuote.vue?vue&type=template&id=50fc98de&scoped=true&"
import script from "./ReviewQuote.vue?vue&type=script&lang=js&"
export * from "./ReviewQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc98de",
  null
  
)

export default component.exports